import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from './../../services/auth.service';
import { Component, OnInit, Renderer2, Input } from '@angular/core';
import { Select2OptionData } from 'ng2-select2';
import { PNotifyService } from '../../services/pnotify.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  @Input() hasFilter: boolean;

  collaps = false;
  clientId = '';
  clients = [];
  pnotify = undefined;
  public clientsData: Array<Select2OptionData>;

  constructor(
    private renderer: Renderer2,
    private authService: AuthService,
    private router: Router,
    private http: HttpClient,
    pnotifyService: PNotifyService
  ) {
    this.initClientSelect();
    this.pnotify = pnotifyService.getPNotify();
  }

  ngOnInit() {
  }

  fliterClicked(event: MouseEvent) {
    const $filterFixed = $('.filterFixed');
    const $fliterTtoggle = $('#fliter_toggle');
    if ($filterFixed.hasClass('open')) {
      $filterFixed.removeClass('open');
    } else {
      $filterFixed.addClass('open');
    }
  }




  onResize(event) {
    const innerWidth = event.target.innerWidth;
    const body = $('body');
    const menu = $('#sidebar-menu');
    if (innerWidth >= 992) {
      menu.find('li.active-sm ul').show();
      menu.find('li.active-sm').addClass('active').removeClass('active-sm');
      menu.addClass('left_col_lg').removeClass('left_col_sm');
      body.addClass('nav-md').removeClass('nav-sm');
    }
  }

  get user() {
    return JSON.parse(localStorage.getItem('user'));
  }

  get role() {
    return localStorage.getItem('role');
  }

  logout(){
    let client =  JSON.parse(localStorage.getItem('user'));
    if (client.pack == 1){
      this.router.navigate(['/logout/pro']);
    } else {
      this.router.navigate(['/logout/school']);
    }
  }

  initClientSelect() {
    this.http.get(
      '/api/client/lookup'
    ).subscribe((clients: any[]) => {
      // this.clientId = clients.length ? clients[0].id : '';
      this.clients = clients;
      const array1 = [{ id: '', text: 'Choisir un client' }];
      const array2 = this.clients.map(function (client, index) {
        return { id: client.id, text: client.name, disabled: false };
      });
      this.clientsData = array1.concat(array2);
    });
  }
  clientChanged(e: any) {
    this.clientId = e.value;
  }

  switchToSuperClient() {
    this.authService.switchToSuperClient(this.clientId).then(
      res => {
        $('#clientsModal').modal('hide');
        this.router.navigate(['']);
      },
      err => {
        // TODO : show error
        this.pnotify.error({
          title: 'Erreur',
          text: 'Une erreur est survenue !',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          }
        });
      }
    );
  }

  switchToAdmin() {
    this.authService.switchToAdmin().then(
      res => {
        this.router.navigate(['']);
      },
      err => {
        // TODO : show error
        this.pnotify.error({
          title: 'Erreur',
          text: 'Une erreur est survenue !',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          }
        });
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/header/header.component.ts